import { render, staticRenderFns } from "./CandidatesKSA.vue?vue&type=template&id=7f1f7037&scoped=true"
import script from "./CandidatesKSA.vue?vue&type=script&lang=js"
export * from "./CandidatesKSA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1f7037",
  null
  
)

export default component.exports